import { ___ } from 'classes/Translation';


export default () => ({
	default: {
		grafit: { label: ___('Grafit'), color: '444444' },
		szary: { label: ___('Szary'), color: '999999' },
		bialy: { label: ___('Biały'), color: 'eeeeee' },
	},
});